import { IMAGE_MAX_DIMENSIONS, IMAGE_MAX_DIMENSIONS_EXTENDED, VIDEO_MAX_DIMENSIONS } from './constants';

let imageMaxDimensions: number = IMAGE_MAX_DIMENSIONS;

export const getImageMaxDimensions = (): number => imageMaxDimensions;

export const setExtendedImageDimensionsEnabled = (enabled: boolean): void => {
    imageMaxDimensions = enabled ? IMAGE_MAX_DIMENSIONS_EXTENDED : IMAGE_MAX_DIMENSIONS;
};

export const getVideoMaxDimensions = (): number => VIDEO_MAX_DIMENSIONS;
